<template>
    <div :class="wrapperClass !== undefined ? wrapperClass : 'w-100'">
        <div v-if="!isNaN(iconset)" class="w-100">
            <div
                class="w-100 my-2 p-0 cursor-pointer widget-overflow"
                :class="{ 'justify-content-around': session }"
                :style="selectedIconset === iconset ? 'border: solid 1px #d64571' : ''"
                @click="session ? null : $emit('select-iconset')"
            >
                <div class="d-flex py-1">
                    <div
                        v-for="(_, i) in iconsets[iconset]"
                        v-if="iconsets[iconset].length <= 6 || i < iconsets[iconset].length - 2"
                        class="d-flex flex-column justify-content-center align-items-center text-white cursor-pointer position-relative mx-1"
                        :class="{ 'size-mini': mini, 'size-full': !mini }"
                        :style="{
                            backgroundColor: iconsets[iconset][i]
                                ? iconsets[iconset][i].color
                                : 'gray',
                            outline: selectedPrompt === i ? '1px solid #d64571' : '',
                            outlineOffset: '1px',
                            overflow: 'hidden',
                        }"
                        @click="
                            session ? $emit('select-prompt', [iconsets[iconset][i].value, i]) : null
                        "
                    >
                        <span class="" :class="{ 'prompt-logo-mini': mini, 'prompt-logo': !mini }">
                            <span v-if="iconsets[iconset][i].icon">
                                <i class="fa" :class="iconsets[iconset][i].icon"></i>
                            </span>
                            <span v-if="iconsets[iconset][i].letter">
                                <span>{{ iconsets[iconset][i].letter }}</span>
                            </span>
                        </span>
                        <span v-if="!mini" class="prompt-description pb-2">
                            <div
                                :style="
                                    iconsets[iconset][i].description.length > 10
                                        ? 'text-align: center; font-size: 80%; line-height: 0.85;'
                                        : ''
                                "
                            >
                                {{ iconsets[iconset][i].description }}
                            </div>
                        </span>
                        <hr v-if="slash && iconsets[iconset][i].value" class="slashed" />
                    </div>
                </div>
                <div class="d-flex py-1">
                    <!--Offset 6-->
                    <div
                        v-for="(_, i) in iconsets[iconset]"
                        v-if="iconsets[iconset].length >= 6 && i >= iconsets[iconset].length - 2"
                        class="mt-1 d-flex flex-column justify-content-center align-items-center text-white cursor-pointer mx-1"
                        :class="{ 'size-mini': mini, 'size-full': !mini }"
                        :style="{
                            backgroundColor: iconsets[iconset][i]
                                ? iconsets[iconset][i].color
                                : 'gray',
                            outline: selectedPrompt === i ? '1px solid #d64571' : '',
                            outlineOffset: '1px',
                        }"
                        @click="
                            session ? $emit('select-prompt', [iconsets[iconset][i].value, i]) : null
                        "
                    >
                        <span class="" :class="{ 'prompt-logo-mini': mini, 'prompt-logo': !mini }">
                            <span v-if="iconsets[iconset][i].icon">
                                <i class="fa" :class="iconsets[iconset][i].icon"></i>
                            </span>
                            <span v-if="iconsets[iconset][i].letter">
                                <span>{{ iconsets[iconset][i].letter }}</span>
                            </span>
                        </span>
                        <span v-if="!mini" class="prompt-description pb-2">
                            <span>{{ iconsets[iconset][i].description }}</span>
                        </span>
                        <hr v-if="slash && iconsets[iconset][i].value" class="slashed" />
                    </div>
                </div>
            </div>
        </div>
        <div
            v-else=""
            :class="{ 'size-mini': mini, 'size-full': !mini }"
            class="cursor-pointer"
            :style="{
                backgroundColor: iconsets[prompt[1]][prompt[2]]
                    ? iconsets[prompt[1]][prompt[2]].color
                    : '#fff',
            }"
        >
            <div class="d-flex flex-column justify-content-center align-items-center text-white">
                <span
                    class=""
                    :class="{ 'prompt-logo-mini': mini, 'prompt-logo': !mini }"
                    style="margin-top: -0.25rem;"
                >
                    <span v-if="iconsets[prompt[1]][prompt[2]].icon">
                        <i class="fa" :class="iconsets[prompt[1]][prompt[2]].icon"></i>
                    </span>
                    <span v-if="iconsets[prompt[1]][prompt[2]].letter">
                        <span>{{ iconsets[prompt[1]][prompt[2]].letter }}</span>
                    </span>
                </span>

                <span v-if="!mini" class="prompt-description pb-2">
                    <span>{{ iconsets[prompt[1]][prompt[2]].description }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PromptIcon",
    props: [
        "mini",
        "prompt",
        "iconset",
        "selectedIconset",
        "selectedPrompt",
        "session",
        "slash",
        "wrapperClass",
    ],
    data() {
        return {
            iconsets: [
                [
                    {
                        color: "#d53e3f",
                        icon: "fa-child",
                        letter: null,
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: "fa-hand-paper-o fa-rotate-90",
                        letter: null,
                        description: "Gestural",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: "fa-comments-o",
                        letter: null,
                        description: "Verbal",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: "fa-thumbs-o-up fa-flip-horizontal",
                        letter: null,
                        description: "Independ",
                        value: 1,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "P",
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: null,
                        letter: "G",
                        description: "Gestural",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: null,
                        letter: "V",
                        description: "Verbal",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: null,
                        letter: "I",
                        description: "Independ",
                        value: 1,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "P",
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "M",
                        description: "Model",
                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: null,
                        letter: "G",
                        description: "Gestural",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: null,
                        letter: "V",
                        description: "Verbal",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: null,
                        letter: "I",
                        description: "Independ",
                        value: 1,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "P",
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "V",
                        description: "Verbal",

                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: null,
                        letter: "M",
                        description: "Model",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: null,
                        letter: "G",
                        description: "Gestural",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: null,
                        letter: "I",
                        description: "Independ",
                        value: 1,
                    },
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "PP",
                        description: "Partial",
                        value: 0,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "PV",
                        description: "Partial",
                        value: 0,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: "fa-times",
                        letter: null,
                        description: "Incorrect",
                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: "fa-minus",
                        letter: null,
                        description: "Approx",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: "fa-plus",
                        letter: null,
                        description: "Correct",
                        value: 1,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: "fa-times",
                        letter: null,
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "MAX",
                        description: "Prompt",
                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: null,
                        letter: "MOD",
                        description: "Prompt",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: null,
                        letter: "MIN",
                        description: "Prompt",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: "fa-plus",
                        letter: null,
                        description: "Correct",
                        value: 1,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: "fa-times",
                        letter: null,
                        description: "Incorrect",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: "fa-plus",
                        letter: null,
                        description: "Correct",
                        value: 1,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "P",
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "V",
                        description: "Verbal",

                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: null,
                        letter: "M",
                        description: "Model",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: null,
                        letter: "G",
                        description: "Gestural",
                        value: 0,
                    },
                    {
                        color: "#00cbfc",
                        icon: null,
                        letter: "–",
                        description: "Approx",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: null,
                        letter: "I",
                        description: "Independ",
                        value: 1,
                    },
                    {
                        color: "#d53e3f",
                        icon: null,
                        letter: "PP",
                        description: "Partial",
                        value: 0,
                    },
                    {
                        color: "#f99808",
                        icon: null,
                        letter: "PV",
                        description: "Partial",
                        value: 0,
                    },
                ],
                [
                    {
                        color: "#d53e3f",
                        icon: "fa-child",
                        letter: null,
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: "fa-hand-paper-o fa-rotate-90",
                        letter: null,
                        description: "Gestural",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: "fa-comments-o",
                        letter: null,
                        description: "Verbal",
                        value: 0,
                    },
                    {
                        color: "#00cbfc",
                        icon: null,
                        letter: "I P",
                        description: "Item Present",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: null,
                        letter: "M O",
                        description: "MO",
                        value: 1,
                    },
                ],
                [
                    {
                        color: "#00cbfc",
                        icon: null,
                        letter: "X",
                        description: "Incorrect",
                        value: 0,
                    },
                    {
                        color: "#d53e3f",
                        icon: "fa-child",
                        letter: null,
                        description: "Physical",
                        value: 0,
                    },
                    {
                        color: "#f6d70c",
                        icon: "fa-hand-paper-o fa-rotate-90",
                        letter: null,
                        description: "Gestural",
                        value: 0,
                    },
                    {
                        color: "#42e6c7",
                        icon: "fa-comments-o",
                        letter: null,
                        description: "Verbal",
                        value: 0,
                    },
                    {
                        color: "#58dd55",
                        icon: "fa-thumbs-o-up fa-flip-horizontal",
                        letter: null,
                        description: "Independ",
                        value: 1,
                    },
                ],
            ],
        };
    },
};
</script>

<style scoped lang="scss">
.prompt-logo {
    letter-spacing: -4px;
    font-size: 1.8rem;
}

.prompt-logo-mini {
    font-size: 0.9rem;
}

.prompt-description {
    margin-top: -0.5rem;
    font-size: 0.75rem;
}

.size-mini {
    max-width: 1.2rem;
    min-width: 1.2rem;
    max-height: 1.2rem;
    min-height: 1.2rem;
}

.size-full {
    max-width: 3rem;
    min-width: 3rem;
    max-height: 3rem;
    min-height: 3rem;
}

.widget-overflow {
    overflow-x: auto;
    overflow-y: hidden;
}

.slashed {
    width: 100px;
    height: 2px;
    color: #d53e3f;
    background-color: #d53e3f;
    border-color: #d53e3f;
    z-index: 2;
    transform: rotate(-45deg);
    position: absolute;
    left: -35px;
    bottom: -3px;
}
</style>
